import React from 'react';

import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import violetLinkedIn from 'icons/violetLinkedin.svg';
import Image from 'next/image';
import type { StaticImageData } from 'next/image';

type ContactPersonProps = {
  role: string;
  name: string;
  src: StaticImageData;
  linkedin: string;
};

export const ContactPerson = ({ role, name, src, linkedin }: ContactPersonProps) => {
  return (
    <Flex w="190px" as="a" href={linkedin} target="_blank" gap="13px" alignItems="center">
      <Grid flexShrink={0} gridTemplateColumns={'1fr'} gridTemplateRows={'1fr'} position="relative">
        <GridItem colStart={1} rowStart={1}>
          <Flex justifyContent="center" alignItems="center">
            {' '}
            <Image src={src} alt={name} style={{ borderRadius: '100%' }} height={80} width={80} />
          </Flex>
        </GridItem>
        <Box
          position="absolute"
          bottom="-13px"
          left="36%"
          as={violetLinkedIn}
          height={26}
          width={26}
          bg={'violet.50'}
          p={'3px'}
          borderRadius="3px"
        />
      </Grid>
      <Box>
        <Text variant="contactPerson/title">{name}</Text>
        <Text variant="contactPerson/role">{role}</Text>
      </Box>
    </Flex>
  );
};
